module.exports = __webpack_public_path__ + "static/media/solutionWorkflow.614328d9.png";